import { render } from "./video-player-mini.vue?vue&type=template&id=d2a5b948"
import script from "./video-player-mini.vue?vue&type=script&lang=js"
export * from "./video-player-mini.vue?vue&type=script&lang=js"

import "./video-player-mini.vue?vue&type=style&index=0&id=d2a5b948&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__